import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class newsletterTemplateEdit_template extends vnTemplate {

    public headerColorSelector: filterDropdown_template;
    public headerLogoSelector: filterDropdown_template;
    public senderEmailSelector: filterDropdown_template;
    public contentPrimaryColorSelector: filterDropdown_template;
    public contentSecondaryColorSelector: filterDropdown_template;
    public sidebarBackgroundColorSelector: filterDropdown_template;

    protected getTemplateHtml(): string {

        return `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title">Newsletter Template</h3>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

                </div>
                <div class="w-form-body">
                    <div class="form-body">

                        <div class="form-group">
                            <label for="subject" class="form-label">Title</label>
                            <div class="row link">
                                <input id="subject" data-bind="value: name" type="text" class="input-text">
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="subject" class="form-label">Sender Email Name</label>
                            <div class="row link">
                                <input id="subject" data-bind="value: senderName" type="text" class="input-text">
                            </div>
                        </div>
                        <div class="form-group">
                                <label for="logoUrl" class="form-label">Sender Email Address</label>
                                ${this.senderEmailSelector.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <label for="subject" class="form-label">UTM Source</label>
                            <div class="row link">
                                <input id="subject" data-bind="value: utmSource" type="text" class="input-text">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Available for Use on</label>
                            <div class="row link">
                                <input type="checkbox" data-bind=" checked: isEmails" id="emails">
                                <label for="emails" class="form-label icon i-check">Emails</label>
                            </div>
                            <div class="row link">
                                <input type="checkbox" data-bind=" checked: isInteractionEmails" id="interactionEmails">
                                <label for="interactionEmails" class="form-label icon i-check">Interaction Emails</label>
                            </div>
                            <div class="row link">
                                <input type="checkbox" data-bind=" checked: isLoginSystemEmails" id="loginSystemEmails">
                                <label for="loginSystemEmails" class="form-label icon i-check">Login System Emails</label>
                            </div>
                        </div>

                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <label for="">Header Preview</label>
                            <div class="preview-header" data-bind="style:{'background-color': color()}, css: { 'full-width': isBannerImageFullWidth }">
                                <img data-bind="attr: {src: logo()}">
                            </div>
                        </div>
                        <div class="form-group-row">
                            <div class="form-group" style="flex:0 20%;">
                                 <label for="headerColor" class="form-label">Header Background Color</label>
                                 ${this.headerColorSelector.getHtmlBuild()}
                            </div>
                            <div class="form-group" style="flex:0 20%;">
                                 <label for="logoUrl" class="form-label">Header Image</label>
                                 ${this.headerLogoSelector.getHtmlBuild()}
                            </div>
                            <div class="form-group checkbox-fix">
                                <label for="logoUrl" class="form-label">Header Image Occupies Full Width</label>
                                <div class="checkbox-fix">
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind=" checked: isBannerImageFullWidth" id="isBannerImageFullWidth">
                                        <label for="isBannerImageFullWidth" class="form-label icon i-check">Enable</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group checkbox-fix">
                                <label class="form-label">Include Send Date Under Header</label>
                                <div class="checkbox-fix">
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind=" checked: includeSendDateUnderHeader" id="includeSendDateUnderHeader">
                                        <label for="includeSendDateUnderHeader" class="form-label icon i-check">Enable</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <hr>
                        </div>
                        <div class="form-group-row">
                            <div class="form-group" style="flex:0 20%;">
                                 <label for="logoUrl" class="form-label">Content Text Primary Color</label>
                                 ${this.contentPrimaryColorSelector.getHtmlBuild()}
                            </div>
                            <div class="form-group" style="flex:0 20%;">
                                 <label for="logoUrl" class="form-label">Content Text Secondary Color</label>
                                 ${this.contentSecondaryColorSelector.getHtmlBuild()}
                            </div>
                            <div class="form-group" style="flex:0 20%;">
                                 <label for="logoUrl" class="form-label">Sidebar Background Color</label>
                                 ${this.sidebarBackgroundColorSelector.getHtmlBuild()}
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="form-footer">
                    <button data-bind="event: { click: onClickCancelEdit }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
            `;

    }

    protected getTemplateName(): string {

        return "newsletterTemplateEdit-template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["div"];
    }

    protected initPartial() {

        this.headerColorSelector = new filterDropdown_template('headerColorSelector', this.getTemplateViewModel(), this.caller);
        this.headerColorSelector.setLabel('Template');

        this.headerLogoSelector = new filterDropdown_template('headerLogoSelector', this.getTemplateViewModel(), this.caller);
        this.headerLogoSelector.setLabel('Template');
        
        this.contentPrimaryColorSelector = new filterDropdown_template('primaryColorSelector', this.getTemplateViewModel(), this.caller);
        this.contentPrimaryColorSelector.setLabel('Template');
        
        this.contentSecondaryColorSelector = new filterDropdown_template('secondaryColorSelector', this.getTemplateViewModel(), this.caller);
        this.contentSecondaryColorSelector.setLabel('Template');

        this.sidebarBackgroundColorSelector = new filterDropdown_template('sidebarBackgroundColorSelector', this.getTemplateViewModel(), this.caller);
        this.sidebarBackgroundColorSelector.setLabel('Template');
        
        this.senderEmailSelector = new filterDropdown_template('senderEmailSelector', this.getTemplateViewModel(), this.caller);
        this.senderEmailSelector.setLabel('Template');
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            senderName: ko.observable(""),
            utmSource: ko.observable(""),
            color: ko.observable(""),
            logo: ko.observable(""),
            isEmails: ko.observable(false),
            isInteractionEmails: ko.observable(false),
            isLoginSystemEmails: ko.observable(false),
            isBannerImageFullWidth: ko.observable(false),
            includeSendDateUnderHeader: ko.observable(true),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_templates'])),
            onClickCancelEdit: function (data, event) {
                self.cancelEdit();

            },
            onClickSave: function (data, event) {
                self.onClickSave()
            },
        }
    }

    getViewModelForRequest(): any {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            senderName: this.getTemplateViewModel().senderName(),
            utmSource: this.getTemplateViewModel().utmSource(),
            headerColor: this.headerColorSelector.getTemplateViewModel().selectedOption,
            headerLogo: this.headerLogoSelector.getTemplateViewModel().selectedOption,
            contentPrimaryColor: this.contentPrimaryColorSelector.getTemplateViewModel().selectedOption,
            contentSecondaryColor: this.contentSecondaryColorSelector.getTemplateViewModel().selectedOption,
            sidebarBackgroundColor: this.sidebarBackgroundColorSelector.getTemplateViewModel().selectedOption,
            sender: this.senderEmailSelector.getTemplateViewModel().selectedOption,
            isEmails: this.getTemplateViewModel().isEmails,
            isInteractionEmails: this.getTemplateViewModel().isInteractionEmails,
            isLoginSystemEmails: this.getTemplateViewModel().isLoginSystemEmails,
            isBannerImageFullWidth: this.getTemplateViewModel().isBannerImageFullWidth(),
            includeSendDateUnderHeader: this.getTemplateViewModel().includeSendDateUnderHeader()
        };
    }

    public setName(name) {

        this.getTemplateViewModel().name(name)
    }

    public setSenderName( senderName) {

        this.getTemplateViewModel().senderName(senderName);
    }
    
    public setUtmSource( utmSource) {

        this.getTemplateViewModel().utmSource(utmSource);
    }
    
    public setColor( color) {

        this.getTemplateViewModel().color(color);
    }
    
    public setLogo( logo) {

        this.getTemplateViewModel().logo(logo);
    }

    public setId( id) {

        this.getTemplateViewModel().id(id);
    }

    public setHeaderColors( options) {

        this.headerColorSelector.setOptions(options);
    }

    public setContentPrimaryColors( options) {

        this.contentPrimaryColorSelector.setOptions(options);
    }

    public setContentSecondaryColors( options) {

        this.contentSecondaryColorSelector.setOptions(options);
    }

    public setSidebarBackgroundColors( options) {

        this.sidebarBackgroundColorSelector.setOptions(options);
    }

    public setLogoUrls( options) {

        options.unshift({'id':null,'name':'Select An Option'});
        this.headerLogoSelector.setOptions(options);
    }
    
    public setSenders( options) {

        options.unshift({'id':null,'name':'Select An Option'});
        this.senderEmailSelector.setOptions(options);
    }

    public setIsEmails(value){
        
        this.getTemplateViewModel().isEmails(value);
    }

    public setIsInteractionEmails(value){
        
        this.getTemplateViewModel().isInteractionEmails(value);
    }
    
    public setIsLoginSystemEmails(value){
        
        this.getTemplateViewModel().isLoginSystemEmails(value);
    }

    public setIsBannerImageFullWidth(value){

        this.getTemplateViewModel().isBannerImageFullWidth(value);
    }

    public setIncludeSendDateUnderHeader(value){

        // templates created before this option existed have no stored value and default to enabled
        let isEnabled = (value === null || value === undefined) ? true : !!value;
        this.getTemplateViewModel().includeSendDateUnderHeader(isEnabled);
    }

    public onClickSave(){

        this.caller.save();
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    public cancelEdit() {

        this.caller.redirectToNewsletterTemplateList()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/newsletterTemplateEdit_template.ts